<template>
  <!--
    Standalone shell for the unauthenticated contractor portal: no sidebar, no
    header, nothing that would fetch on behalf of a session that does not exist.
  -->
  <div class="bg-muted min-h-screen px-4 py-8 sm:py-12">
    <div class="mx-auto w-full max-w-3xl">
      <slot />
    </div>
  </div>
</template>
